import type { TFunction } from 'i18next'

type ResolveCampaignTitleInput = {
  rawTitle?: string | null
  ownerName?: string | null
  fallbackTitle?: string | null
  t: TFunction
}

const genericCampaignTitles = new Set(['my campaign', 'mi campaña', 'minha campanha'])

function normalizeWhitespace(value: string | null | undefined): string {
  if (!value) {
    return ''
  }
  return value.trim().replace(/\s+/g, ' ')
}

function firstName(value: string | null | undefined): string {
  const normalized = normalizeWhitespace(value)
  if (!normalized) {
    return ''
  }
  return normalized.split(' ')[0] ?? ''
}

export function isGenericCampaignTitle(rawTitle: string | null | undefined): boolean {
  const title = normalizeWhitespace(rawTitle).toLowerCase()
  if (!title) {
    return true
  }
  return genericCampaignTitles.has(title)
}

export function resolveCampaignDisplayTitle({
  rawTitle,
  ownerName,
  fallbackTitle,
  t,
}: ResolveCampaignTitleInput): string {
  const normalizedTitle = normalizeWhitespace(rawTitle)
  if (normalizedTitle && !isGenericCampaignTitle(normalizedTitle)) {
    return normalizedTitle
  }

  const ownerFirstName = firstName(ownerName)
  if (ownerFirstName) {
    const translated = String(
      t('campaign.generatedTitleByName', {
        name: ownerFirstName,
        defaultValue: `${ownerFirstName} Campaign`,
      })
    )
    return translated === 'campaign.generatedTitleByName'
      ? `${ownerFirstName} Campaign`
      : translated
  }

  const fallback =
    normalizeWhitespace(fallbackTitle) ||
    String(t('campaign.publicFallbackTitle', { defaultValue: 'Campaign' }))
  return fallback || 'Campaign'
}
